import { ILoadingOverlayComp } from "ag-grid-community";
import type { ICompileService, IRootScopeService } from "angular";

export default class CVLoadingOverlay implements ILoadingOverlayComp {
    private gui: HTMLElement;

    private $compile: ICompileService;
    private $rootScope: IRootScopeService;

    constructor() {
        // load required services from angularJS
        const $injector = angular.element("div[id='ClearViewApp']").injector();
        this.$compile = $injector.get('$compile');
        this.$rootScope = $injector.get('$rootScope');
    }

    init() {
        this.gui = document.createElement('div');
        this.gui.classList.add('position-relative');
        this.$compile('<cv-loader></cv-loader>')(this.$rootScope, ($loader) => $loader.appendTo(this.gui));
    }

    getGui(): HTMLElement {
        return this.gui;
    }
}
